import { serializeArrowSchema, parseGeometryFromArrow } from '@loaders.gl/arrow';
import { getGeometryColumnsFromSchema } from '@loaders.gl/gis';
export function convertApacheArrowToArrowTable(arrowTable) {
  return {
    shape: 'arrow-table',
    schema: serializeArrowSchema(arrowTable.schema),
    data: arrowTable
  };
}
export function convertArrowToGeoJSONTable(table) {
  const arrowTable = table.data;
  const schema = serializeArrowSchema(arrowTable.schema);
  const geometryColumns = getGeometryColumnsFromSchema(schema);
  const encoding = geometryColumns.geometry.encoding;
  const features = [];
  const propertyColumnNames = arrowTable.schema.fields.map(field => field.name).filter(name => !(name in geometryColumns));
  const propertiesTable = arrowTable.select(propertyColumnNames);
  const arrowGeometryColumn = arrowTable.getChild('geometry');
  for (let row = 0; row < arrowTable.numRows; row++) {
    const arrowGeometry = arrowGeometryColumn === null || arrowGeometryColumn === void 0 ? void 0 : arrowGeometryColumn.get(row);
    const feature = parseGeometryFromArrow(arrowGeometry, encoding);
    if (feature) {
      var _propertiesTable$get;
      const properties = ((_propertiesTable$get = propertiesTable.get(row)) === null || _propertiesTable$get === void 0 ? void 0 : _propertiesTable$get.toJSON()) || {};
      features.push({
        type: 'Feature',
        geometry: feature,
        properties
      });
    }
  }
  return {
    shape: 'geojson-table',
    type: 'FeatureCollection',
    schema: table.schema,
    features
  };
}
//# sourceMappingURL=convert-arrow-to-geojson-table.js.map